
import { Component, Prop, Vue } from "vue-property-decorator";
import { Answer } from "@/lib/model/exam/result";
import DescribeData from "@/views/paper/paper-result-report/component/describe.vue";
import dimendionDesc from "@/lib/dimension/high-low-desc";
import BtnBase from "./btn-base.vue";
import DialogOCEAN from "./dialog-OCEAN.vue";

@Component({ components: { DescribeData, BtnBase, DialogOCEAN } })
export default class Psychological extends Vue {
  @Prop() index!: number;
  @Prop({ type: Answer, default: () => new Answer() }) mindData!: Answer;
  @Prop({ default: false }) pdfIng!: boolean;

  visible = false; // 弹窗是否显示
  // 纬度(高/低)描述
  dimendionDesc(dimensionName: string) {
    if (!dimendionDesc[dimensionName]) return {};
    return dimendionDesc[dimensionName];
  }
}
